class Menu {
    constructor(swiper, listenerPage) {
        this.menu               = document.querySelector(".navbar-menu");
        this.closeMenuCross     = document.getElementById("close-menu");
        this.caretDown          = document.getElementById("caret-down");
        this.header             = document.getElementById('header');
        this.navbar             = document.querySelector('.navbar-start');
        this.burger             = document.getElementById('navbar-burger');
        this.anchors            = this.navbar.querySelectorAll('.anchor');
        this.links              = this.navbar.querySelectorAll('.link');
        this.body               = document.querySelector('body');
        this.headerDefaultClass = this.header.className;
        this.swiper             = swiper;
        this.listenerPage       = listenerPage;
        this.animationDuration  = 500;

        this.displayMenu();
        this.createListener();
    }

    createListener() {

        if (this.body.className.match(this.listenerPage)) {
            window.addEventListener('resize', () => this.displayMenu());
            this.swiper.on('slideChange', () => {
                setTimeout(() => {
                    if (this.swiper.slides[this.swiper.activeIndex].id !== '' && this.swiper.activeIndex >= 2) {
                        this.header.className = this.headerDefaultClass;
                        this.header.classList.add(this.swiper.slides[this.swiper.activeIndex].id);
                        this.navbar.classList.remove('is-clicked-while-slider-is-active');
                    } else if (this.swiper.activeIndex < 2) {
                        this.header.className = this.headerDefaultClass;
                    }
                }, 100);
            });

            // Open the full menu
            this.navbar.addEventListener('click', (e) => this.showMenu(e));

            const HEADER_CLASS = [this.headerDefaultClass, this.headerDefaultClass + ' menu-active'];
            for (let i = 0; i < this.anchors.length; i++) {
                const ANCHOR = this.anchors[i];
                ANCHOR.addEventListener('click', () => {
                    if (this.menuIsOpen() && (HEADER_CLASS.indexOf(this.header.className) !== -1 || this.navbar.classList.contains('is-clicked-while-slider-is-active'))) {
                        const ID_SECTION = ANCHOR.href.split('#')[1];
                        if (window.innerWidth <= 1024) {
                            this.closeMenu();
                        }
                        this.goToSection(ID_SECTION);
                    }
                })
            }

            for (let i = 0; i < this.links.length; i++) {
                const LINK = this.links[i];
                LINK.addEventListener('click', () => {
                    window.location = LINK.href;
                })
            }
        }

        this.burger.addEventListener('click', (e) => {
            console.log("lol");
            this.showMenu(e);
            this.openMenu();
        });
        this.closeMenuCross.addEventListener('click', () => this.closeMenu());
    }

    displayMenu() {
        if (window.innerWidth > 1024 && !this.menuIsOpen()) {
            this.openMenu();
        } else if (window.innerWidth <= 1024 && this.menuIsOpen()) {
            this.closeMenu();
        }
    }

    menuIsOpen() {
        return this.menu.classList.contains('active-on-click');
    }

    showMenu(e) {
        e.preventDefault();

        if (!this.isSubPage()) {
            this.header.className = this.headerDefaultClass;
        } else {
            this.navbar.classList.add('is-clicked-while-slider-is-active');
        }
    }

    isSubPage() {
        return this.body.classList.contains('slider-is-active');
    }

    openMenu() {
        this.menu.classList.add('active-on-click');
        this.menu.classList.add('active');

        // For mobile device
        this.closeMenuCross.classList.add('active');
        this.header.classList.add('menu-active');
        this.caretDown.classList.add('inactive');
        this.burger.style.display = 'none';
        const CURRENT_SECTION     = this.getCurrentSection();
        if (CURRENT_SECTION) {
            CURRENT_SECTION.classList.add('responsive-menu-is-open');
        }
    }

    closeMenu() {
        this.menu.classList.remove('active-on-click');
        this.menu.classList.remove('active');

        // For mobile device
        this.closeMenuCross.classList.remove('active');
        this.header.classList.remove('menu-active');
        this.burger.style.display = '';
        this.caretDown.classList.remove('inactive');

        const CURRENT_SECTION = this.getCurrentSection();

        if (CURRENT_SECTION) {
            CURRENT_SECTION.classList.remove('responsive-menu-is-open');
            if(this.swiper.activeIndex >= 2){
                this.header.classList.add(this.swiper.slides[this.swiper.activeIndex].id);
            }
        }
    }

    goToSection(sectionId) {
        let animation = 0;
        if (this.isSubPage()) {
            this.getCurrentSection().querySelector('.back').click();
            animation = this.animationDuration;
        }

        setTimeout(() => {
            this.swiper.slideTo(this.getSectionIndexTarget(sectionId), this.animationDuration, false);
        }, animation);
    }

    getSectionIndexTarget(sectionId) {
        let index = this.swiper.activeIndex;

        for (let i = 0; i < this.swiper.slides.length; i++) {
            if (this.swiper.slides[i].id === `${sectionId}-section`) {
                index = i;
                break;
            }
        }

        return index;
    }

    getCurrentSection() {
        return document.querySelector('.swiper-slide-active');
    }
}